export const AUTH_API = `${process.env.REACT_APP_API_URL}/auth`;
export const USER_API = `${process.env.REACT_APP_API_URL}/user`;
export const EVENT_API = `${process.env.REACT_APP_API_URL}/event`;
export const DEVICE_TYPE_API = `${process.env.REACT_APP_API_URL}/device-type`;
export const TAG_API = `${process.env.REACT_APP_API_URL}/tag`;
export const DEVICE_API = `${process.env.REACT_APP_API_URL}/device`;
export const RULE_API = `${process.env.REACT_APP_API_URL}/rule`;
export const GROUP_API = `${process.env.REACT_APP_API_URL}/group`;
export const MSB_API = `${process.env.REACT_APP_API_URL}/msb`;
export const VIOLATION_API = `${process.env.REACT_APP_API_URL}/violation`;
export const FILE_API = `${process.env.REACT_APP_API_URL}/file`;
export const RULE_CHANGELOG_API = `${process.env.REACT_APP_API_URL}/rule-changelog`;
export const VAR_AUDIT_API = `${process.env.REACT_APP_API_URL}/var-audit`;
export const LOCATION_API = `${process.env.REACT_APP_API_URL}/location`;
export const COMPLIANCE_API = `${process.env.REACT_APP_API_URL}/compliance`;
export const SECTOR_API = `${process.env.REACT_APP_API_URL}/sector`;
export const VALIDATION_RESULT_API = `${process.env.REACT_APP_API_URL}/validation-result`;
export const VALIDATE_API = `${process.env.REACT_APP_API_URL}/validate`;
export const VALIDATION_WHITELIST_API = `${process.env.REACT_APP_API_URL}/whitelist`;
export const LOG_API = `${process.env.REACT_APP_API_URL}/log`;
export const BACKUP_API = `${process.env.REACT_APP_API_URL}/dump`;
export const LICENSE_API = `${process.env.REACT_APP_API_URL}/license`;
export const REPORT_API = `${process.env.REACT_APP_REPORT_API_URL}/report`;
export const REPORT_SCHEDULE_API = `${process.env.REACT_APP_REPORT_API_URL}/reportschedule`;
export const AIML_RESULTS_API = `${process.env.REACT_APP_REPORT_API_URL}/aiml-results`;
export const AIML_SETTINGS_API = `${process.env.REACT_APP_REPORT_API_URL}/aiml-settings`;
export const MAIL_RECIPIENT_API = `${process.env.REACT_APP_MAILER_API_URL}/mail/recipient`;
export const MAIL_ACCOUNT_API = `${process.env.REACT_APP_MAILER_API_URL}/mail/account`;
export const SYSTEM_API = `${process.env.REACT_APP_API_URL}/system`;
//DevTeam Feb 24, 2022
export const UPGRADE_API = `${process.env.REACT_APP_API_URL}/upgrade`;
export const RETENTION_API= `${process.env.REACT_APP_API_URL}/retention`;
//DevTeam July 5, 2022
//export const EXPORT_DATA = `${process.env.REACT_APP_API_URL}/export-data`
//DevTeam Aug 11, 2022
export const PARAMETER_API = `${process.env.REACT_APP_API_URL}/parameter`;
//DevTeam Sep 22, 2022
export const CONFIG_CHANGES_API = `${process.env.REACT_APP_API_URL}/config-changes`;
//DevTeam Oct 28, 2022
export const SYSTEM_SETTINGS_API = `${process.env.REACT_APP_API_URL}/system-settings`;
//DevTeam Apr 06, 2023
export const AUTH_SERVER_API = `${process.env.REACT_APP_API_URL}/auth-server`;
//DevTeam Apr 26, 2023
export const DEVICE_BASELINE_API = `${process.env.REACT_APP_API_URL}/device-baseline`;
//DevTeam Aug 22, 2023
export const USER_ROLE_API = `${process.env.REACT_APP_API_URL}/user-role`;
export const USERROLE_CAPABILITY_API = `${process.env.REACT_APP_API_URL}/userrole-capability`;
export const REMEDIATE_API = `${process.env.REACT_APP_API_URL}/remediate`;
export const SYSLOGSERVER_API = `${process.env.REACT_APP_API_URL}/syslogserver`;
export const VALIDATION_SCHEDULE_API = `${process.env.REACT_APP_API_URL}/validationschedule`;
export const NMAP_CONFIG_API = `${process.env.REACT_APP_MAILER_API_URL}/nmapconfig`;
export const NMAP_SCAN_API = `${process.env.REACT_APP_MAILER_API_URL}/nmapscan`;
export const NMAP_INVENTORY_API = `${process.env.REACT_APP_MAILER_API_URL}/nmapinventory`;
export const NMAP_SCANSCHEDULE_API = `${process.env.REACT_APP_MAILER_API_URL}/nmapscanschedule`;
export const DOMAIN_MANAGEMENT_API = `${process.env.REACT_APP_API_URL}/domain-management`;
export const CONFIG_CHANGES_RESULT_API = `${process.env.REACT_APP_API_URL}/config-changes-result`;
export const CENTRAL_CREDENTIALS_API = `${process.env.REACT_APP_API_URL}/central-credentials`;
export const SEND_MAIL_API = `${process.env.REACT_APP_MAILER_API_URL}/sendmail`;
export const SYSTEM_Mail_API = `${process.env.REACT_APP_MAILER_API_URL}/system`;
export const VIOLATION_RESULT_API = `${process.env.REACT_APP_API_URL}/violation-result`;
export const DEVICE_AUTHORIZATION_API = `${process.env.REACT_APP_API_URL}/device-authorization`;
export const CHATBOT_API = `${process.env.REACT_APP_AIML_API_URL || "/api3"}`;
export const REMEDIATION_IMPACT_API = `${process.env.REACT_APP_REMEDIATION_IMPACT_API_URL || "/api4"}`;
export const CONFIG_ACTION_ANOMALY_API = `${process.env.REACT_APP_CONFIG_ACTION_ANOMALY_API_URL || "/api5"}`;
export const CHATBOT_ENABLED = `${process.env.REACT_APP_CHATBOT_ENABLED || "false"}`.toLowerCase() === "true";

export const DeviceStatus = {
    CONNECTED: "CONNECTED",
    UNKNOWN: "UNKNOWN",
    DISCONNECTED: "DISCONNECTED"
}

export const BaselineStatus = {
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
}

export const ValidationStatus = {
    DONE: "DONE",
    PROCESSING: "PROCESSING",
    ERROR: "ERROR"
}

export const ScanStatus = {
    DONE: "DONE",
    PROCESSING: "PROCESSING",
    ERROR: "ERROR"
}
export const RuleExpectedCondition = {
    CONTAINS: "CONTAINS",
    NOT_CONTAINS: "NOT_CONTAINS",
    EQUALS: "EQUALS",
    STARTS_WITH: "STARTS_WITH",
    ENDS_WITH: "ENDS_WITH"
}

export const RuleRelation = {
    AND: "AND",
    OR: "OR",
}

export const EventType = {
    KEYWORD: "KEYWORD",
    REGEX: "REGEX"
}

export const LicenseErrorMessages = {
    NOT_FOUND: "License not found",
    EXPIRED: "License expired"
}

export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
